export default "__VITE_ASSET__453a2d13__"